import React from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/routes';
import Button from 'components/Button';
import Etrc from 'assets/images/store-logo-etsy-overlay.png';
import Shopify from 'assets/images/store-logo-shopify-overlay.png';
import WooCommerceLogo from 'assets/svg/WooCommerceLogo';
import COLORS from 'shared/constants/colors';
import SubHeader from 'components/SubHeader';
import StoreTable from 'pages/my-stores/stores/StoresTable';
import { Container, Img, Section } from 'styles/pages/my-stores/stores';

const Stores = () => {
  const history = useHistory();
  return (
    <>
      <SubHeader
        title='Browse'
        links={[
          {
            title: ROUTES.DASHBOARD.TITLE,
            to: ROUTES.DASHBOARD.LINK,
          },
        ]}
        currentPageTitle={ROUTES.MY_STORES.TITLE}
      />
      <Container>
        <Section>
          <Button
            containerStyle={{
              fontSize: '14px',
              minWidth: '120px',
              borderRadius: '3px',
              padding: '7px 5px',
              lineHeight: '1.5',
              textTransform: 'inherit',
              color: COLORS.WHITE,
              backgroundColor: COLORS.BLACK,
            }}
            variant='text'
            title='Add Store'
            onClick={() => history.push(ROUTES.MY_STORES_REGISTRATION.LINK)}
          />
          {/* <Img src={Etrc} alt='etrc-logo' /> */}
          <Img src={Shopify} alt='shopify-logo' />
          <WooCommerceLogo
            style={{ marginLeft: 15, opacity: 0.5, marginTop: 5 }}
          />
        </Section>
        <StoreTable />
      </Container>
    </>
  );
};

export default Stores;
